export default "__VITE_ASSET__BL8$P9ZF__"